export default __webpack_public_path__ + "static/media/CBMERP_BG.8f207baf.jpg";